export const DevWorkData=[{
    id:1,
    title:"Assemble the right team",
    description:"We handle all aspects of vetting and choosing the right team that you don't have the time, expertise, or desire to do."
}, {
    id: 2,
    title: "Sprint planning",
    description: "Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding."
},
{
    id: 3,
    title: "Tech architecture",
    description: "We break monolithic apps into microservices. Decoupling the code allows teams to move faster and more independently"
},
{
    id: 4,
    title: "Standups & weekly demos",
    description: "Standups, weekly demos, and weekly reviews make sure everyone is on the same page and can raise their concerns."
},
{
    id: 5,
    title: "Code reviews",
    description: "Code reviews before release help detect issues like memory leaks, file leaks, performance signs, and general bad smells"
},
{
    id: 6,
    title: "Iterative delivery",
    description: "We divide the implementation process into several checkpoints rather than a single deadline."
}]